<template>
  <div class="bankc">
    <Header class="get-header" titles="银行卡类型"></Header>
    <input type="text" class="search" @keyup="chooseBank" v-model="ins" placeholder="搜索">
    <List
      class="bank-list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getBankList"
      >
      <div class="bank-eve" v-for="item in banks" :key="item.id" @click="chooseBack(item.name)">{{item.name}}</div>
    </List>
    <div class="no-content" v-if="!banks.length">{{'没有搜索的内容'}}</div>
  </div>
</template>

<script>
import { List } from 'vant'
import Header from '@/components/header'
import { getBank } from '@/api/api/user.js'
export default {
  data() {
    return {
      finished: false,
      banks: [],
      loading: false,
      page: 1,
      total: 10,
      ins: ''
    }
  },
  created() {
  },
  components: {
    Header,
    List
  },
  methods: {
    chooseBack(x) {
      this.$store.commit('SET_BANK', x)
      this.$store.commit('SET_BRANCH', '')
      this.$router.back()
    },
    getBankList() {
      if(this.page*10 > this.total+10) {
        this.finished = true
        return
      }
      getBank(this.page++, this.ins).then(res => {
        if(res.data.errorCode === 0) {
          this.banks = [...this.banks,...res.data.data.list]
          this.total = res.data.data.total
        }
        this.loading = false
      })
    },
    chooseBank(e) {
      if(e.keyCode === 13) {
        this.page = 3
        this.finished = false
        getBank(1, this.ins, 20).then(res => {
          if(res.data.errorCode === 0) {
            this.banks = res.data.data.list
            this.total = res.data.data.total
            if(this.page*10 > this.total+10) {
              this.finished = true
              return
            }
          }
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bankc {
  min-height: 100%;
  padding-top: 44px;
  background-color: rgb(246, 246, 244);
  .no-content {
    text-align: center;
    color: #ccc;
  }
  .search {
    margin: 0 10%;
    padding-left: 6px;
    margin-top: 10px;
    height: 45px;
    width: 80%;
    border: 1px solid #e8e8e8;
  }
  .bank-list {
    margin-top: 10px;
    .bank-eve {
      border-bottom: 1px solid #d8d8d8;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: white;
    }
  }
}
</style>